import { IData } from '../interface';

const render = (data: IData) => {
    if (data.SYSTEM === '"CN"' || data.SYSTEM === 'CN') {
        return '<script src="https://statics-cdn-cn.umucdn.cn/common/qrcode.min.v1.js" type="text/javascript"></script>';
    }

    return '<script src="https://cdn.umustatic.com/common/qrcode.min.v1.js" type="text/javascript"></script>';
};

export default render;
